import * as styles from "./DialogDescription.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Dialog as BaseDialog } from "@base-ui/react/dialog";

import type { DialogDescriptionProps } from "./Dialog.types";

export function DialogDescription({
  className,
  ...props
}: DialogDescriptionProps): JSX.Element {
  return (
    <BaseDialog.Description
      data-slot="dialog-description"
      className={clsx(styles.description, className)}
      {...props}
    />
  );
}
